<template>
	<div id="wrapper">
        <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" :class="{ 'toggled' : !sidebarToggled }" id="accordionSidebar">
            <a class="sidebar-brand d-flex align-items-center justify-content-center" href="/app">
                <div class="sidebar-brand-icon rotate-n-15">
                    <img src="/images/logo-light-icon.png" width="60%">
                </div>
                <div class="sidebar-brand-text mx-3"><img src="https://httpsredirect.com/images/logo-light.png" width="100%"></div>
            </a>
            <hr class="sidebar-divider my-0">
            <li class="nav-item active">
                <router-link class="nav-link" :to="{ name: 'app' }">
                    <i class="fas fa-globe-americas"></i>
                    <span>Domains</span>
                </router-link>
            </li>
            <li class="nav-item active">
                <router-link class="nav-link" :to="{ name: 'billing' }">
                    <i class="fas fa-fw fa-dollar-sign"></i>
                    <span>Billing</span>
                </router-link>
            </li>
            <hr class="sidebar-divider d-none d-md-block">
            <div class="text-center d-none d-md-inline">
                <button @click="sidebarToggled = !sidebarToggled" class="rounded-circle border-0" id="sidebarToggle"></button>
            </div>
        </ul>
        <div id="content-wrapper" class="d-flex flex-column" v-if="$auth.check() && $auth.ready()">
            <div id="content">
                <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                    <button @click="sidebarToggled = !sidebarToggled" id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
                        <i class="fa fa-bars"></i>
                    </button>
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item">
                            <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ user.full_name }}</span>
                        </li>
                        <li class="nav-item">
                            <button @click="logout" class="btn-plain"><i class="fa fa-sign-out-alt"></i></button>
                        </li>
                    </ul>
                </nav>
                <router-view></router-view>
                <div class="wrapper-push"></div>
            </div>
            <notifications position="bottom right"/>
            <footer class="sticky-footer bg-white">
                <div class="container my-auto">
                    <div class="copyright my-auto">
                        <span>Copyright &copy; <a style="color: initial;" target="_blank" rel="noopener" href="https://tctechss.com">TC Tech Support & Solutions, LLC</a> d.b.a. <b>HTTPSredirect</b></span>
                        <div class="float-sm-right mt-2 mt-sm-0">
                            <router-link :to="{ name: 'terms' }" class="text-dark mr-3">Terms and Conditions</router-link>
                            <router-link :to="{ name: 'privacy' }" class="text-dark">Privacy Policy</router-link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
	export default {
  		name: 'AppLayout',
  		data() {
  			return {
  				sidebarToggled: false,
  			}
  		},
  		computed: {
  			user() {
  				return this.$auth.user();
  			}
  		},
        watch: {
            $route(to, from) {
                // hide sidebar when link clicked on small screen
                if (window.innerWidth <= 992) {
                    this.sidebarToggled = false;
                }
            },
        },
        methods: {
            logout() {
                this.$auth.logout({
                    makeRequest: true,
                    redirect: { name: 'login' },
                });
            }
        }
  	};
</script>